let lastTime;

export default (errMessage, error = '') => {
  console.debug(errMessage);
  if (location.host.includes('fuzoku-fan.jp') || location.host.includes('cti-first.net')) {
    const now = new Date().getTime();
    if (lastTime && now < lastTime + 60000) {
      return;
    }
    lastTime = now;
    const params = new URLSearchParams();
    params.set('method', 'notifyError');
    let src = '';
    if (location.host == 'cti3795.fuzoku-fan.jp') src = '[3795]';
    if (location.host == 'cti3796.fuzoku-fan.jp') src = '[3796]';
    params.set('error', `${src}${error}`);
    if (errMessage && errMessage.includes('QuotaExceededError')) {
      navigator.storage.estimate()
        .then((data) => {
          params.set('message', `${errMessage}\n${JSON.stringify(data)}`);
          fetch(`${location.protocol}//${location.host}/ajax/top/notifyadmin`, {
            method: 'POST',
            body: params,
            mode: 'cors',
            credentials: 'include'
          });
        })
        .catch(() => {
          params.set('message', errMessage);
          fetch(`${location.protocol}//${location.host}/ajax/top/notifyadmin`, {
            method: 'POST',
            body: params,
            mode: 'cors',
            credentials: 'include'
          });
        });
      return;
    }
    params.set('message', errMessage);
    fetch(`${location.protocol}//${location.host}/ajax/top/notifyadmin`, {
      method: 'POST',
      body: params,
      mode: 'cors',
      credentials: 'include'
    });
  }
};